<template>
  <div class="edit-event">
    <section>
      <b-field label="Title">
        <b-input
          type="text"
          v-model="event.title"
          placeholder="Event Title"
          required
        ></b-input>
      </b-field>
      <b-field label="Poster">
        <b-input
          type="text"
          v-model="event.posterUri"
          placeholder="Event Poster Url"
          required
        ></b-input>
      </b-field>
      <b-notification type="is-success" indefinite>
        <p>Sheet Music (One Page) : {{ event.posterUri }}</p>
      </b-notification>
      <p>Uploading : {{ this.isUploading }}</p>
      <b-field label="Sheet Music (Image) - Upload">
        <b-upload class="file-label" v-model="filePath">
          <span class="file-cta">
            <span class="file-label">Click to Upload</span>
          </span></b-upload
        >
      </b-field>
      <b-field label="Description">
        <b-input
          type="textarea"
          v-model="event.description"
          placeholder="Description"
          required
        ></b-input>
      </b-field>
      <div class="columns">
        <div class="column">
          <b-field v-if="event.startDate" label="Start Date">
            <b-datepicker
              v-model="event.startDate"
              placeholder="Click to select..."
              icon="calendar"
              position="is-top-right"
            >
              <button class="button is-primary" @click="date = new Date()">
                <b-icon icon="calendar"></b-icon>
                <span>Today</span>
              </button>
            </b-datepicker>
          </b-field>
        </div>
        <div class="column">
          <b-field v-if="event.startDate" label="Time">
            <b-timepicker
              v-model="event.startDate"
              :inline="false"
              :enable-seconds="true"
              :mobile-native="true"
              icon="clock-o"
            ></b-timepicker>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field v-if="event.endDate" label="End Date">
            <b-datepicker
              v-model="event.endDate"
              placeholder="Click to select..."
              icon="calendar"
              position="is-top-right"
            >
              <button class="button is-primary" @click="date = new Date()">
                <b-icon icon="calendar"></b-icon>
                <span>Today</span>
              </button>
            </b-datepicker>
          </b-field>
        </div>
        <div class="column">
          <b-field v-if="event.endDate" label="Time">
            <b-timepicker
              v-model="event.endDate"
              :inline="false"
              :enable-seconds="true"
              :mobile-native="true"
              icon="clock-o"
            ></b-timepicker>
          </b-field>
        </div>
      </div>
      <div v-if="eventId">
        <b-field label="Tags">
          <div class="select is-multiple">
            <select multiple :size="allTags.length" v-model="event.tags">
              <option v-for="tag in allTags" :key="tag.id" :value="tag.id">
                {{ tag.name }}
              </option>
            </select>
          </div>
        </b-field>
      </div>
      <div class="controls">
        <button class="button is-primary" @click="saveEvent">Save</button>
        <button v-if="eventId" class="button is-danger" @click="deleteEvent">
          {{ deleteEventText }}
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import { firestore, storage } from "@/firebase";

var db = firestore;
var firebaseStorage = storage;

export default {
  name: "EditEvent",
  props: ["eventId"],
  data() {
    return {
      allTags: [],
      deletingEvent: false,
      filePath: null,
      isUploading: false,
      editingEvent: false,
      event: {
        title: null,
        description: null,
        posterUri: null,
        startDate: null,
        endDate: null,
        tags: [],
      },
    };
  },
  mounted() {
    //Pull all tags
    db.collection("Tag")
      .get()
      .then((snapshot) => {
        let tags = snapshot.docs.map((d) => {
          var data = d.data();
          data.id = d.id;
          return data;
        });
        this.allTags = tags;
      });

    if (this.eventId) {
      // Pull linked tags
      db.collection("EventTag")
        .where("eventId", "==", this.eventId)
        .onSnapshot((snapshot) => {
          let tags = snapshot.docs.map((d) => {
            return d.data().tagId;
          });
          this.event.tags = tags;
        });

      let ref = `/Events/${this.eventId}`;
      db.doc(ref)
        .get()
        .then((doc) => {
          if (doc.exists) {
            console.log("Document exists and available for editing");
            this.editingEvent = true;
            let eventData = doc.data();
            this.event.title = eventData.title;
            this.event.description = eventData.description;
            this.event.posterUri = eventData.posterUri;
            this.event.startDate = new Date(eventData.startDate.seconds * 1000);
            this.event.endDate = new Date(eventData.endDate.seconds * 1000);
          } else {
            this.$toast.open({
              message: "No such document available",
              type: "is-danger",
              duration: 3000,
              position: "is-bottom",
            });
            this.$router.go(-1);
          }
        })
        .catch((error) => {
          console.log("error getting document : " + error);
        });
    } else {
      console.log("creating a new expense");
      this.event.startDate = new Date();
      this.event.endDate = new Date();
    }
  },
  methods: {
    deleteEvent: function () {
      if (this.deletingEvent) {
        let ref = `/Events/`;
        db.collection(ref)
          .doc(this.eventId)
          .delete()
          .then(() => {
            console.log("event deleted");
            this.$toast.open({
              message: "The event has been deleted",
              type: "is-success",
              duration: 3000,
              position: "is-bottom",
            });
            this.$router.go(-1);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.deletingEvent = true;
      }
    },
    saveTags: function () {
      if (this.eventId) {
        db.collection("EventTag")
          .where("eventId", "==", this.eventId)
          .get()
          .then((snapshot) => {
            console.log("Deleting old entries");
            for (var doc of snapshot.docs) {
              db.collection("EventTag").doc(doc.id).delete();
            }

            console.log("Adding new entries");
            for (var tag of this.event.tags) {
              db.collection("EventTag").add({
                eventId: this.eventId,
                tagId: tag,
              });
            }
          });
      }
    },
    saveEvent: function () {
      var dataToSave = {
        title: this.event.title,
        description: this.event.description,
        startDate: this.event.startDate,
        posterUri: this.event.posterUri,
        endDate: this.event.endDate,
      };
      var saveSuccessFullHanlder = () => {
        this.saveTags();
        console.log("Successfull added event");
        this.$toast.open({
          message: "The event has been recorded",
          type: "is-success",
          duration: 3000,
          position: "is-bottom",
        });
        this.$router.go(-1);
      };

      if (this.eventId) {
        let ref = `/Events`;
        db.collection(ref)
          .doc(this.eventId)
          .update(dataToSave)
          .then(saveSuccessFullHanlder);
      } else {
        let ref = `/Events`;
        console.log(ref);
        db.collection(ref)
          .add(dataToSave)
          .then(saveSuccessFullHanlder)
          .catch((error) => {
            console.log("Error adding event : " + error);
          });
      }
    },
  },
  computed: {
    deleteEventText: function () {
      if (this.deletingEvent) {
        return "Confirm Delete";
      } else {
        return "Delete";
      }
    },
  },
  watch: {
    filePath: function () {
      console.log("File Selected");
      console.log(firebaseStorage);
      var storageRef = firebaseStorage.ref("poster");
      var thisRef = storageRef.child(this.filePath.name);
      this.isUploading = true;
      thisRef.put(this.filePath).then((snapshot) => {
        console.log(snapshot);
        console.log("Uploaded a blob or file! : " + thisRef.fullPath);
        this.isUploading = false;
        thisRef.getDownloadURL().then((url) => {
          this.event.posterUri = url;
        });
      });
    },
  },
};
</script>

<style>
.controls button {
  margin-left: 10px;
}
</style>